import { computed } from 'mobx'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'
import type { ActivationLifecycle } from '@/infra/activation'
import type { SubmittedJob } from '@/features/jobs/details/SubmittedJob'
import type { MiscJobType } from '@/features/jobs/job-type'
import type { DefaultJobConversationViewModel } from '../JobConversationViewModel'
import { NEVER, type Observable } from 'rxjs'

/**
 * Misc job specific view model.
 */
export class MiscJobDetailsViewModel implements ActivationLifecycle {
  private readonly _lifecycle = new LifecycleTracker()

  /**
   * Observable that emits when the user should be bounced from the misc job details.
   * Currently misc jobs don't have any bounce conditions.
   */
  readonly bounce$: Observable<unknown> = NEVER

  constructor(
    public readonly job: SubmittedJob,
    public readonly jobConversationVm: DefaultJobConversationViewModel,
  ) {}

  @computed
  get type() {
    // We know this is safe.
    return this.job.type as MiscJobType
  }

  /** @inheritDoc */
  activate() {
    this._lifecycle.activate()
  }

  /** @inheritDoc */
  deactivate() {
    this._lifecycle.deactivate()
  }

  /**
   * Fetches data needed for the view to be able to render.
   */
  async fetch(_signal?: AbortSignal) {
    // Nothing to fetch for this job type.
  }
}
